// ===================
//      modaal
// ===================

$(".gallery").modaal({
	type: "image"
});

// ===================
//      swiper
// ===================

// ページ内のすべてのswiper-container要素を取得
const swiperContainers = document.querySelectorAll(".swiper-container");

swiperContainers.forEach((container, index) => {
	const swiperSlides = container.querySelectorAll(".swiper-slide");
	const length = swiperSlides.length;
	let middleIndex;
	// 中央の値を計算
	if (length % 2 === 0) {
		middleIndex = Math.floor(length / 2) - 1;
	} else {
		middleIndex = Math.floor(length / 2);
	}

	// 各swiper-container要素にIDを追加
	const swiperId = `swiper-${index + 1}`;
	container.id = swiperId;

	// Swiperを初期化
	const swiper_new = new Swiper(`#${swiperId} .swiper_coverFlow`, {
		loop: true,
		slidesPerView: 1,
		centeredSlides: true,
		initialSlide: middleIndex, // 中央値を設定
		effect: "coverflow",
		coverflowEffect: {
			rotate: 0,
			depth: 0,
			stretch: 0,
			scale: 0.9,
			slideShadows: true
		},
		breakpoints: {
			490: {
				slidesPerView: 3
			}
		},
		pagination: {
			el: `#${swiperId} .swiper-pagination`
		},
		navigation: {
			nextEl: `#${swiperId} .swiper-button-next`,
			prevEl: `#${swiperId} .swiper-button-prev`
		}
	});
});

// ===================
//      swiper district
// ===================

// ページ内のすべてのswiper-container要素を取得
const swiperContainers02 = document.querySelectorAll(".swiper-container02");

swiperContainers02.forEach((container, index) => {
	const swiperSlides02 = container.querySelectorAll(".swiper-slide");
	const length = swiperSlides02.length;
	let middleIndex02;
	// 各swiper-container要素にIDを追加
	const swiperId = `swiper-${index + 1}`;
	container.id = swiperId;

	// 中央の値を計算
	if (length === 2) {
		middleIndex02 = 0; // 2つの場合は最初の要素を中央とする
		const swiper_new02 = new Swiper(`#${swiperId} .swiper_coverFlow`, {
			loop: false,
			slidesPerView: 1,
			centeredSlides: true,
			initialSlide: 0, // 中央値を設定
			effect: "coverflow",
			coverflowEffect: {
				rotate: 0,
				depth: 0,
				stretch: 0,
				scale: 0.7,
				slideShadows: true
			},
			breakpoints: {
				490: {
					slidesPerView: 3
				}
			},
			pagination: {
				el: `#${swiperId} .swiper-pagination`
			},
			navigation: {
				nextEl: `#${swiperId} .swiper-button-next`,
				prevEl: `#${swiperId} .swiper-button-prev`
			}
		});
	} else {
		// 中央の値を計算
		if (length % 2 === 0) {
			middleIndex02 = Math.floor(length / 2) - 1;
		} else {
			middleIndex02 = Math.floor(length / 2);
			console.log(length);
			console.log(middleIndex02);
		}
		const swiper_new02 = new Swiper(`#${swiperId} .swiper_coverFlow`, {
			loop: length > 3,
			slidesPerView: 1,
			centeredSlides: true,
			initialSlide: middleIndex02, // 中央値を設定
			effect: "coverflow",
			coverflowEffect: {
				rotate: 0,
				depth: 0,
				stretch: 0,
				scale: 0.7,
				slideShadows: true
			},
			breakpoints: {
				490: {
					slidesPerView: 3
				}
			},
			pagination: {
				el: `#${swiperId} .swiper-pagination`
			},
			navigation: {
				nextEl: `#${swiperId} .swiper-button-next`,
				prevEl: `#${swiperId} .swiper-button-prev`
			}
		});
	}

	// Swiperを初期化
});

// swiper scroll
// ===============================
const swiperScroll = document.querySelectorAll(".swiper-scroll");

swiperScroll.forEach((container, index) => {
	const swiperSlides = container.querySelectorAll(".swiper-slide");
	const swiperId = `swiper-${index + 1}`;
	container.id = swiperId;
	const length = swiperSlides.length;
	const slidePerViewPCAttr = container.getAttribute("data-swiperSlidePC");
	const slidePerViewSPAttr = container.getAttribute("data-swiperSlideSP");
	const slidePerViewPC = slidePerViewPCAttr === "auto" ? "auto" : parseFloat(slidePerViewPCAttr) || 3;
	const slidePerViewSP = slidePerViewSPAttr === "auto" ? "auto" : parseFloat(slidePerViewSPAttr) || 1.8;
	const direction = container.getAttribute("data-direction") || "horizontal";
	const mousewheelAttr = container.getAttribute("mousewheelControl");
	const mousewheel = mousewheelAttr === "true";
	const slideCentered = container.hasAttribute("slideCentered");
	const freeMode = container.hasAttribute("freeMode");
	if (length <= 3) {
		const swiper_scroll = new Swiper(`#${swiperId}.swiper-scroll`, {
			slidesPerView: slidePerViewSP,
			freeMode: freeMode,
			direction: direction === "vertical" ? "vertical" : direction,
			spaceBetween: 15,
			centeredSlides: slideCentered,
			mousewheel: mousewheel,
			scrollbar: {
				el: `#${swiperId} + .swiper-scrollbar`,
				hide: false,
				draggable: true
			},
			breakpoints: {
				740: {
					slidesPerView: slidePerViewPC,
					spaceBetween: 30
				}
			},
			pagination: {
				el: `#${swiperId} .swiper-pagination`
			},
			navigation: {
				nextEl: `#${swiperId} .swiper-button-next`,
				prevEl: `#${swiperId} .swiper-button-prev`
			}
		});
	} else {
		const swiper_scroll = new Swiper(`#${swiperId}.swiper-scroll`, {
			slidesPerView: slidePerViewSP,
			freeMode: freeMode,
			direction: direction,
			spaceBetween: 15,
			centeredSlides: slideCentered,
			mousewheel: mousewheel,
			scrollbar: {
				el: `#${swiperId} + .swiper-scrollbar`,
				hide: false,
				draggable: true
			},
			breakpoints: {
				740: {
					slidesPerView: slidePerViewPC,
					spaceBetween: 30
				}
			},
			pagination: {
				el: `#${swiperId} .swiper-pagination`
			},
			navigation: {
				nextEl: `#${swiperId} .swiper-button-next`,
				prevEl: `#${swiperId} .swiper-button-prev`
			}
		});
	}
});

// アコーディオンのJavaScriptコードを追加
document.addEventListener("DOMContentLoaded", function () {
	var accordionItems = document.querySelectorAll(".nav-list_category");

	accordionItems.forEach(function (item) {
		item.addEventListener("click", function (event) {
			// nav-list_category内のaタグがクリックされた場合はリンクを実行
			if (event.target.closest("a")) {
				return;
			}

			var parentItem = item.closest(".nav-list_item");

			if (parentItem.classList.contains("active")) {
				parentItem.classList.remove("active");
			} else {
				accordionItems.forEach(function (otherItem) {
					var otherParentItem = otherItem.closest(".nav-list_item");
					if (otherParentItem !== parentItem) {
						otherParentItem.classList.remove("active");
					}
				});
				parentItem.classList.add("active");
			}
		});
	});

	var subItems = document.querySelectorAll(".nav-list_sub li");

	subItems.forEach(function (subItem) {
		subItem.addEventListener("click", function (event) {
			// サブアイテムがクリックされてもアコーディオンが閉じないようにする
			event.stopPropagation();
		});
	});
});

$(".product-spec").find("span").text("商品仕様（サイズ等）");

var flag = "";

$(function () {
	$(window).on("load resize", function () {
		var w = $(window).innerWidth();

		// SP幅の場合
		if (w <= 740) {
			// フラグが"sp"でない場合のみ処理を実行
			if (flag !== "sp") {
				flag = "sp";
				// SP時の処理
				$(".product-spec .tab-content").css("display", "none");
				$(".product-description .tab-buttons").click(function () {
					$(".product-description .tab-content").slideToggle();
					$(this).toggleClass("isHide");
				});
				$(".product-spec .tab-buttons").click(function () {
					$(".product-spec .tab-content").slideToggle();
					$(this).toggleClass("isOpen");
				});
			}
		}
		// PC幅の場合
		else {
			// フラグが"pc"でない場合のみ処理を実行
			if (flag !== "pc") {
				flag = "pc";
				$(".product-description .tab-buttons").removeClass("isHide");
				$(".product-description .tab-content").css("display", "block");
				// PCの場合はSPのイベントリスナーを削除する
				$(".product-description .tab-buttons, .product-spec .tab-buttons").off("click");
			}
		}
	});
});

const swiper = new Swiper(".swiper-related", {
	loop: "true",
	// Optional parameters
	direction: "horizontal",
	// If we need pagination
	pagination: {
		el: ".swiper-pagination"
	},
	// Navigation arrows
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev"
	},
	// And if we need scrollbar
	scrollbar: {
		el: ".swiper-scrollbar"
	}
});

// ページトップボタン
// =================================
document.addEventListener("DOMContentLoaded", function () {
	const breakPoint_md = 739;
	const backButton = document.querySelector(".el_btn_back");
	const footer = document.querySelector("footer");
	const container = document.getElementById("anker_back");

	function handleScrollEvent() {
		const screenWidth = window.innerWidth;

		// 739px 以下の場合のみスクロールイベントを実行
		if (screenWidth <= breakPoint_md) {
			// backButton.style.display = "none"; // イベントを有効にする場合、ボタンが表示されるようにする
			window.addEventListener("scroll", onScroll);
		} else {
			// 739px以上の場合、ボタンを非表示
			backButton.style.display = "none";
			window.removeEventListener("scroll", onScroll); // スクロールイベントを解除
		}
	}

	function onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const scrollHeight = document.documentElement.scrollHeight; // ドキュメントの高さ
		const windowHeight = window.innerHeight; // ウィンドウの高さ
		const scrollPosition = windowHeight + scrollTop; // 現在のスクロール位置
		const footHeight = footer.offsetHeight; // フッターの高さ
		const containerTop = container.getBoundingClientRect().top + scrollTop; // 要素の上部位置
		const containerBottom = containerTop + container.offsetHeight; // 要素の下部位置

		// 100px以上スクロールでボタンを表示
		if (scrollTop > 100) {
			backButton.style.display = "block";
		} else {
			backButton.style.display = "none";
		}

		// フッターの手前でボタンを固定解除
		if (scrollHeight - scrollPosition <= footHeight + 90) {
			backButton.style.position = "absolute";
			backButton.style.bottom = footHeight + 110 + "px"; // フッターの上部に配置
		} else {
			backButton.style.position = "fixed";
			backButton.style.bottom = "20px";
		}
	}

	// 初期状態でウィンドウサイズに基づくイベントを適用
	handleScrollEvent();

	// ウィンドウリサイズ時にも処理を実行
	window.addEventListener("resize", handleScrollEvent);
});
// アコーディオン
// =================================
document.addEventListener("DOMContentLoaded", function () {
	const accordionBlocks = document.querySelectorAll(".bl_accordion");
	let screenWidth = window.innerWidth;
	const breakPoint_md = 739;

	// ブレイクポイントによる表示切り替え
	function applyInitialAccordionState() {
		accordionBlocks.forEach(function (block) {
			// ブレイクポイント以下の画面幅で、かつ js_defaultOpen クラスを含む場合にアコーディオンを開く
			if (screenWidth <= breakPoint_md && block.classList.contains("js_defaultOpen")) {
				block.classList.add("js_isShow");
			} else {
				block.classList.remove("js_isShow");
			}
		});
	}

	// ユニークなIDを生成するための関数
	function generateUniqueId() {
		return "accordion_" + Math.random().toString(36).substr(2, 9);
	}

	// クリックイベント：アコーディオン
	accordionBlocks.forEach(function (block, index) {
		const btn = block.querySelector(".bl_accordion_btn");

		// ブロックにIDを自動割り当て（既にIDがなければ）
		let blockId = block.getAttribute("id");
		if (!blockId) {
			blockId = generateUniqueId();
			block.setAttribute("id", blockId);
		}

		// ボタンのIDとアコーディオンブロックのIDを対応付ける
		if (btn) {
			btn.setAttribute("data-target", blockId);
		}

		btn.addEventListener("click", function () {
			const targetId = btn.getAttribute("data-target");
			const targetAccordion = document.getElementById(targetId);

			// エラーチェック
			if (targetAccordion && targetAccordion.classList) {
				// クリックしたアコーディオンの開閉
				if (targetAccordion.classList.contains("js_isShow")) {
					targetAccordion.classList.remove("js_isShow");
				} else {
					// 全てのアコーディオンを閉じる
					block.classList.remove("js_isShow");

					// クリックされたアコーディオンを開く
					targetAccordion.classList.add("js_isShow");
				}
			} else {
				console.error("Accordion block element is undefined or missing classList property");
			}
		});
	});

	// リロード時にメディアクエリを確認して初期状態を適用
	applyInitialAccordionState();

	// 画面サイズ変更時に初期状態を再適用
	window.addEventListener("resize", () => {
		// 画面幅が変わっていなければリターンする
		if (screenWidth === window.innerWidth) return;

		// 幅が変わっていたら、内容を更新
		screenWidth = window.innerWidth;
		applyInitialAccordionState();
	});
});
